@if (group) {
  <ng-container [formGroup]="group">
    <ng-container *ngTemplateOutlet="formField"></ng-container>
  </ng-container>
}

@if (!group) {
  <ng-container *ngTemplateOutlet="formField"></ng-container>
}

<ng-template #formField>
  <div class="container">
    @if (!hideIconSpace) {
      <mat-icon>{{ icon }}</mat-icon>
    }
    <mat-form-field color="accent">
      @if (showSpinner) {
        <mat-spinner matSuffix [diameter]="20" color="accent" class="suffix-icon"></mat-spinner>
      }
      <mat-label>{{ label | titlecase }}</mat-label>
      <mat-select multiple #select="matSelect" [formControl]="control" (selectionChange)="onEmitSelectionChange($event.value)" disableOptionCentering panelClass="dropDownSelect" panelWidth="fit-content">
        @if (showBlankOption) {
          <mat-option [value]="null"></mat-option>
        }
        @for (option of options; track option.id) {
          <mat-option [value]="option.id">
            @if (shouldCapitalize) {
              <span>{{ option.description | capitalizefirst }}</span>
            }
            @if (!shouldCapitalize) {
              <span>{{ option.description }}</span>
            }
          </mat-option>
        }
      </mat-select>
      <mat-hint [ngClass]="{ highlight: isHintHighlighted, warn: isHintWarning }">{{ hint }}</mat-hint>
      <mat-error>{{ control.errors?.msError == msErrorKey ? customMsError : control.errors?.msError }}</mat-error>
      @if (control.errors?.required) {
        <mat-error>{{ sysText.required | capitalizefirst }}</mat-error>
      }
    </mat-form-field>
    @if (info) {
      <!-- a button so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    }
  </div>
</ng-template>
